import { render, staticRenderFns } from "./cozy-community-info.vue?vue&type=template&id=ffe880f8&lang=pug&"
import script from "./cozy-community-info.vue?vue&type=script&lang=js&"
export * from "./cozy-community-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports